var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429199,
    y: 0.9375,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FBEACE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10534_16821)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4294 9.77344C12.4713 9.77344 9.2627 12.9821 9.2627 16.9401C9.2627 20.8981 12.4713 24.1068 16.4294 24.1068C20.3874 24.1068 23.596 20.8981 23.596 16.9401C23.596 12.9821 20.3874 9.77344 16.4294 9.77344Z",
    fill: "#FBEACE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4294 10.7734C13.0236 10.7734 10.2627 13.5343 10.2627 16.9401C10.2627 20.3459 13.0236 23.1068 16.4294 23.1068C19.8351 23.1068 22.596 20.3459 22.596 16.9401C22.596 13.5343 19.8351 10.7734 16.4294 10.7734ZM9.2627 16.9401C9.2627 12.9821 12.4713 9.77344 16.4294 9.77344C20.3874 9.77344 23.596 12.9821 23.596 16.9401C23.596 20.8981 20.3874 24.1068 16.4294 24.1068C12.4713 24.1068 9.2627 20.8981 9.2627 16.9401Z",
    fill: "#FF6722"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0756 17.2911C15.9819 17.1973 15.9292 17.0701 15.9292 16.9375V12.2708C15.9292 11.9947 16.1531 11.7708 16.4292 11.7708C16.7053 11.7708 16.9292 11.9947 16.9292 12.2708V16.4375H21.0959C21.372 16.4375 21.5959 16.6614 21.5959 16.9375C21.5959 17.2136 21.372 17.4375 21.0959 17.4375H16.4292C16.2966 17.4375 16.1694 17.3848 16.0756 17.2911Z",
    fill: "#FF6722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10534_16821"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.4292,
    y: 8.9375,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.18c3b7b42bf05a784b4757cd552d74ee.svg";
export { ForwardRef as ReactComponent };